module.exports = __webpack_public_path__ + "static/media/thumb_coworking-hub.144e2300.png";